import { useEffect, useRef, useState } from 'react';

const useObserver = () => {
    const [isVisible, setIsVisible] = useState(true);
    const containerRef: any = useRef(null);

    const callbackFn = (entries: any) => {
        const [entry] = entries;
        setIsVisible(entry.isIntersecting);
    };
    useEffect(() => {
        let observerRefValue: any = null;

        const options = {
            root: null,
            rootMargin: '-50px',
            threshold: 0
        };
        const observer = new IntersectionObserver(callbackFn, options);
        if (containerRef.current) {
            observer.observe(containerRef.current);
            observerRefValue = containerRef.current;
        }
        return () => {
            if (observerRefValue) {
                observer.unobserve(observerRefValue);
            }
        };
    }, [isVisible]);

    return [containerRef, isVisible];
};

export default useObserver;
